/**
 * Resumo, em texto, do que mexe nos tempos e no resumo do dia: muda quando um
 * pedido entra ou sai da lista, é cancelado ou ganha o carimbo de uma etapa.
 *
 * Só usa campos que vêm do servidor. O card que o atendente arrasta muda só o
 * `status` na hora (atualização otimista); os carimbos chegam na releitura da
 * lista, quando a etapa já está gravada — assim a conta nunca é refeita antes
 * da mudança existir no banco.
 */
export function assinaturaEtapas(pedidos) {
  return (pedidos || [])
    .map((p) => [p.id, p.ts_producao, p.ts_pronto, p.ts_em_rota, p.ts_concluido, p.status === "cancelado" ? "c" : ""].join("|"))
    .join(";");
}
